var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col w-full blum-report-graph",
      class: { "section-focused": _vm.isFocused },
      style: { padding: "0px 0px 24px 0px", gap: "8px" },
      attrs: { id: "section-graph-" + _vm.section.id }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col items-center text-center",
          style: { gap: "8px" }
        },
        [
          _vm.collection.masteredDate
            ? _c(
                "div",
                [
                  _c("BlTextBody2", {
                    style: { fontSize: "14px" },
                    attrs: { text: "Mastered on" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    style: { fontSize: "14px" },
                    attrs: {
                      text: _vm.displayDate({
                        date: _vm.collection.masteredDate,
                        format: "DD MMM YYYY"
                      })
                    }
                  })
                ],
                1
              )
            : _vm.collection.startDate && _vm.collection.endDate
            ? _c(
                "div",
                [
                  _c("BlTextBody2", {
                    style: { fontSize: "14px" },
                    attrs: { text: "Progress from" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    style: { fontSize: "14px" },
                    attrs: {
                      text: _vm.displayDate({ date: _vm.collection.startDate })
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    style: { fontSize: "14px" },
                    attrs: { text: "to" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    style: { fontSize: "14px" },
                    attrs: {
                      text: _vm.displayDate({ date: _vm.collection.endDate })
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.collection.labels.length > 20 &&
      _vm.useDateInputs &&
      _vm.mode === "edit"
        ? _c(
            "div",
            {
              staticClass: "flex items-center rounded bg-tulip-200",
              style: { padding: "8px 16px", gap: "8px" }
            },
            [
              _c("BlIcon", {
                style: { height: "24px", width: "24px" },
                attrs: { icon: "warning", color: "tulip-7" }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col" },
                [
                  _c("BlTextBody2", {
                    staticClass: "text-tulip-800",
                    attrs: {
                      text:
                        "Your graph contains over 20 data points, which may make it difficult to read. Consider adjusting the date range for better clarity."
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col w-full", style: { gap: "8px" } },
        [
          _vm.section.kind.includes("cumulative")
            ? _c(
                "div",
                { staticClass: "text-grey-400", style: { fontSize: "12px" } },
                [_vm._v("\n      Number of mastered targets\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showDelay
            ? _c("div", {
                staticClass:
                  "grid w-full rounded h-100 place-items-center bg-slate-100 animate-pulse"
              })
            : _vm.graphPreviewLoading
            ? _c(
                "div",
                { staticClass: "grid w-full h-100 place-items-center" },
                [_c("div", { staticClass: "blum-loader" })]
              )
            : _c(
                "div",
                {
                  staticClass:
                    "relative flex items-center justify-center flex-grow"
                },
                [
                  _vm.section.kind === "cumulative_graph_stacked"
                    ? _c("BarChart", {
                        key:
                          "cumulative-stacked-chart-" +
                          _vm.section.id +
                          "-" +
                          _vm.section.updated_at,
                        staticClass: "w-full",
                        attrs: {
                          options: _vm.stackedChartOptions,
                          "chart-data": _vm.collection
                        }
                      })
                    : _vm.section.kind !== "graph_sbt"
                    ? _c("LineChart", {
                        key:
                          "target-line-chart-" +
                          _vm.section.id +
                          "-" +
                          _vm.section.updated_at,
                        staticClass: "w-full",
                        attrs: {
                          options: _vm.lineChartOptions,
                          "chart-data": _vm.collection,
                          plugins: [_vm.multiArbitraryLine]
                        }
                      })
                    : _c(
                        "div",
                        { staticClass: "w-full" },
                        [
                          _c("MixedChart", {
                            attrs: {
                              "chart-data": _vm.collection,
                              "chart-grid-show": true
                            }
                          })
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _vm.isEmptyGraph
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "absolute flex items-center rounded bg-tulip-200",
                          style: { padding: "8px 16px", gap: "8px" }
                        },
                        [
                          _c("BlIcon", {
                            style: { height: "24px", width: "24px" },
                            attrs: { icon: "warning", color: "tulip-7" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col" },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-tulip-800",
                                attrs: {
                                  text:
                                    "No progress found within the selected date range."
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-tulip-800",
                                attrs: {
                                  text:
                                    "Adjust the date range to display data for this " +
                                    (_vm.section.kind.includes("cumulative")
                                      ? "graph"
                                      : "target") +
                                    "."
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          _vm.section.kind.includes("cumulative")
            ? _c(
                "div",
                {
                  staticClass: "self-center text-grey-400",
                  style: { fontSize: "12px" }
                },
                [_vm._v("\n      Date\n    ")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.section.kind === "graph_prompting" &&
      (_vm.promptingProgressBy === "frequency" ||
        _vm.promptingProgressBy === "percentage")
        ? _c(
            "div",
            {
              staticClass: "grid grid-cols-5 rounded-lg bg-slate-200",
              style: { padding: "12px 12px", gap: "16px" }
            },
            [
              _vm._l(_vm.filterUniqueLegends(_vm.collection.prompts), function(
                prompt
              ) {
                return _c(
                  "div",
                  {
                    key: prompt.id,
                    staticClass: "flex items-center",
                    style: { gap: "8px" },
                    attrs: { title: prompt.name }
                  },
                  [
                    prompt.shape && prompt.color
                      ? _c("BlIcon", {
                          style: { width: "20px" },
                          attrs: {
                            icon: "prompt-" + prompt.shape,
                            color: prompt.color
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "truncate capitalize-first",
                      style: { fontSize: "12px" },
                      attrs: { text: prompt.name }
                    })
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.collection.goal
                ? _c(
                    "div",
                    { staticClass: "flex items-center", style: { gap: "8px" } },
                    [
                      _c("div", {
                        staticClass: "flex-shrink-0 rounded-full",
                        style: {
                          backgroundColor: "#71C115",
                          height: "4px",
                          width: "48px"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        style: { fontSize: "12px" },
                        attrs: { text: "Goal" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm.section.kind === "graph_sbt"
        ? _c(
            "div",
            {
              staticClass: "grid grid-cols-5 rounded-lg bg-slate-200",
              style: { padding: "12px 12px", gap: "16px" }
            },
            _vm._l(_vm.filterUniqueLegends(_vm.legends), function(legend, idx) {
              return _c(
                "div",
                {
                  key: "legend-" + idx,
                  staticClass: "flex items-center",
                  style: { gap: "8px" },
                  attrs: { title: legend.label }
                },
                [
                  legend.type === "problemBehavior"
                    ? _c("div", {
                        staticClass: "flex-shrink-0 rounded",
                        style: {
                          backgroundColor: legend.color,
                          height: "16px",
                          width: "16px"
                        }
                      })
                    : _c("div", {
                        staticClass: "flex-shrink-0",
                        style: {
                          backgroundColor: legend.color,
                          height: "2px",
                          width: "32px"
                        }
                      }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "truncate capitalize-first",
                    style: { fontSize: "12px" },
                    attrs: { text: legend.label }
                  })
                ],
                1
              )
            }),
            0
          )
        : _vm.section.kind !== "cumulative_graph_line"
        ? _c(
            "div",
            {
              staticClass: "grid grid-cols-5 rounded-lg bg-slate-200",
              style: { padding: "12px 12px", gap: "16px" }
            },
            [
              _vm.collection.goal
                ? _c(
                    "div",
                    { staticClass: "flex items-center", style: { gap: "8px" } },
                    [
                      _c("div", {
                        staticClass: "flex-shrink-0 rounded-full",
                        style: {
                          backgroundColor: "#71C115",
                          height: "4px",
                          width: "40px"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        style: { fontSize: "12px" },
                        attrs: { text: "Goal" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.collection.hasPhaseLine
                ? _c(
                    "div",
                    { staticClass: "flex items-center", style: { gap: "4px" } },
                    [
                      _c("div", {
                        staticClass: "flex-shrink-0 rounded-full",
                        style: {
                          background:
                            "repeating-linear-gradient(90deg, #E4E4E4 0 6px, white 0 10px)",
                          height: "4px",
                          width: "40px"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        style: { fontSize: "12px" },
                        attrs: { text: "Phase line" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.filterUniqueLegends(_vm.legends), function(
                legend,
                idx
              ) {
                return _c(
                  "div",
                  {
                    key: legend.label + "-" + idx,
                    staticClass: "flex items-center",
                    style: { gap: "8px" },
                    attrs: { title: legend.label }
                  },
                  [
                    _c("div", {
                      staticClass: "flex-shrink-0 rounded-full",
                      style: {
                        backgroundColor: legend.color,
                        height: "16px",
                        width: "16px"
                      }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "truncate capitalize-first",
                      style: { fontSize: "12px" },
                      attrs: { text: legend.label }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "graph-menu",
          class: { "flex-col": _vm.section.kind === "graph_prompting" }
        },
        [
          _vm.section.kind === "graph_prompting" &&
          _vm.defaultPrompts.length &&
          (_vm.promptingProgressBy === "frequency" ||
            _vm.promptingProgressBy === "percentage")
            ? _c(
                "div",
                {
                  staticClass: "mb-2",
                  attrs: { id: "prompting-selection-show" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center flex-shrink-0 w-full gap-3 pb-2 overflow-x-auto scrollbar-lg"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 flex-shrink-0 text-center border rounded cursor-pointer",
                          class: [
                            _vm.isPromptingShowAll
                              ? "border-light-purple-300"
                              : "border-slate-400"
                          ],
                          on: {
                            click: function($event) {
                              return _vm.onTogglePromptingShow("all")
                            }
                          }
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "flex-shrink-0 h-4",
                            attrs: { icon: "prompt-line" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "capitalize-first",
                            attrs: { text: "All graphs" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.defaultPrompts, function(prompt) {
                        return _c(
                          "div",
                          {
                            key: prompt.id,
                            staticClass:
                              "w-30 py-2.5 px-3 flex flex-col items-center justify-center gap-1 flex-shrink-0 text-center border rounded cursor-pointer",
                            class: [
                              prompt.is_show
                                ? "border-light-purple-300"
                                : "border-grey-200"
                            ],
                            attrs: { title: prompt.name },
                            on: {
                              click: function($event) {
                                return _vm.onTogglePromptingShow(prompt)
                              }
                            }
                          },
                          [
                            prompt.shape && prompt.color
                              ? _c("BlIcon", {
                                  staticClass: "flex-shrink-0 w-auto h-4",
                                  attrs: {
                                    icon: "prompt-" + prompt.shape,
                                    color: prompt.color
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass:
                                "w-24 text-center truncate capitalize-first",
                              attrs: { text: prompt.name }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center justify-center gap-3" },
            [
              _c(
                "div",
                {
                  staticClass: "w-6 h-6 cursor-pointer",
                  on: { click: _vm.onClose }
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-6 h-6",
                    attrs: { icon: "close", clickable: "" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.section.kind === "graph_sbt" &&
              _vm.defaultTasks.length &&
              _vm.defaultProblemBehaviors.length
                ? _c("div", { staticClass: "flex items-center gap-3" }, [
                    _c("div", { staticClass: "relative" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative flex items-center justify-between h-8 px-4 border rounded cursor-pointer",
                          class: _vm.isTaskShowAll ? "w-32" : "w-42",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.showTasksOpened = !_vm.showTasksOpened
                            }
                          }
                        },
                        [
                          _c("BlTextBody2", {
                            staticClass: "capitalize-first",
                            attrs: {
                              text: _vm.isTaskShowAll
                                ? "All tasks"
                                : _vm.defaultTasks.filter(function(task) {
                                    return task.is_show
                                  }).length + " task(s)"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass:
                              "absolute w-5 h-5 transition-all duration-300 right-4",
                            style: _vm.showTasksOpened ? "rotate: 180deg" : "",
                            attrs: { icon: "chevron-down" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showTasksOpened
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "absolute z-10 px-4 py-4 mt-5 space-y-4 overflow-y-auto border rounded shadow-md max-h-48 bg-pure-white border-grey-200",
                              class: _vm.isTaskShowAll
                                ? "-right-12 w-56"
                                : "-right-6 w-60"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center gap-2 cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.onToggleTaskShow("all")
                                    }
                                  }
                                },
                                [
                                  _c("BlInputCheck", {
                                    staticClass:
                                      "flex-shrink-0 pointer-events-none",
                                    attrs: { checked: _vm.isTaskShowed("all") }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    attrs: { text: "All tasks" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.defaultTasks, function(task) {
                                return _c(
                                  "div",
                                  {
                                    key: task.id,
                                    staticClass:
                                      "flex items-center gap-2 cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.onToggleTaskShow(task)
                                      }
                                    }
                                  },
                                  [
                                    _c("BlInputCheck", {
                                      staticClass:
                                        "flex-shrink-0 pointer-events-none",
                                      attrs: { checked: _vm.isTaskShowed(task) }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: { text: task.code }
                                    })
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "relative" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative flex items-center justify-between h-8 px-4 border rounded cursor-pointer",
                          class: _vm.isProblemBehaviorShowAll ? "w-55" : "w-64",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.showProblemBehaviorsOpened = !_vm.showProblemBehaviorsOpened
                            }
                          }
                        },
                        [
                          _c("BlTextBody2", {
                            staticClass: "capitalize-first",
                            attrs: {
                              text: _vm.isProblemBehaviorShowAll
                                ? "All problem behaviors"
                                : _vm.defaultProblemBehaviors.filter(function(
                                    pb
                                  ) {
                                    return pb.is_show
                                  }).length + " problem behavior(s)"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass:
                              "absolute w-5 h-5 transition-all duration-300 right-4",
                            style: _vm.showProblemBehaviorsOpened
                              ? "rotate: 180deg"
                              : "",
                            attrs: { icon: "chevron-down" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showProblemBehaviorsOpened
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "absolute z-10 w-64 px-4 py-4 mt-5 space-y-4 overflow-y-auto border rounded shadow-md max-h-48 bg-pure-white border-grey-200",
                              class: _vm.isProblemBehaviorShowAll
                                ? "-right-22"
                                : "-right-14"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center gap-2 cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      return _vm.onToggleProblemBehaviorShow(
                                        "all"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("BlInputCheck", {
                                    staticClass:
                                      "flex-shrink-0 pointer-events-none",
                                    attrs: {
                                      checked: _vm.isProblemBehaviorShowed(
                                        "all"
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    attrs: { text: "All problem behaviors" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.defaultProblemBehaviors, function(pb) {
                                return _c(
                                  "div",
                                  {
                                    key: pb.id,
                                    staticClass:
                                      "flex items-center gap-2 cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.onToggleProblemBehaviorShow(
                                          pb
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("BlInputCheck", {
                                      staticClass:
                                        "flex-shrink-0 pointer-events-none",
                                      attrs: {
                                        checked: _vm.isProblemBehaviorShowed(pb)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody2", {
                                      attrs: { text: pb.code }
                                    })
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "bg-slate-300 h-7.5 flex-shrink-0",
                      staticStyle: { width: "2px" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.useDateInputs
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center gap-2 px-2 py-1 rounded w-140 bg-tulip-200"
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "w-5 h-5",
                        attrs: { icon: "warning", color: "tulip-7" }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-tulip-800",
                            attrs: {
                              text:
                                "This graph can't be modified because it was imported before the report's latest version."
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-tulip-800",
                            attrs: {
                              text:
                                "Please delete it and add a new graph to make adjustments."
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.useDateInputs
                ? _c("div", {
                    staticClass: "h-7.5 w-0.5 bg-slate-300 flex-shrink-0"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.usePromptingProgressBy
                ? _c(
                    "div",
                    { staticClass: "w-64" },
                    [
                      _c("BlSelectBox", {
                        key:
                          "select-graph-progress-by-" +
                          JSON.stringify(_vm.promptingProgressByOptions),
                        attrs: {
                          prefixText: "Progress by",
                          options: _vm.promptingProgressByOptions,
                          dense: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.onChangePromptingProgressBy($event)
                          }
                        },
                        model: {
                          value: _vm.promptingProgressBy,
                          callback: function($$v) {
                            _vm.promptingProgressBy = $$v
                          },
                          expression: "promptingProgressBy"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.usePromptingProgressBy
                ? _c("div", {
                    staticClass: "h-7.5 w-0.5 bg-slate-300 flex-shrink-0"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.useGraphType
                ? _c(
                    "div",
                    { staticClass: "w-40" },
                    [
                      _c("BlSelectBox", {
                        attrs: { options: _vm.graphTypeOptions, dense: "" },
                        on: {
                          change: function($event) {
                            return _vm.onChangeGraphType($event)
                          }
                        },
                        model: {
                          value: _vm.graphType,
                          callback: function($$v) {
                            _vm.graphType = $$v
                          },
                          expression: "graphType"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.useGraphType
                ? _c("div", {
                    staticClass: "h-7.5 w-0.5 bg-slate-300 flex-shrink-0"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.useDateInputs
                ? _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    [
                      _c("BlInputDate", {
                        attrs: {
                          input: _vm.startDateInput,
                          dense: "",
                          disabledManualInput: ""
                        },
                        on: { changed: _vm.onChangeDate }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "h-0.5 w-4 bg-slate-500 flex-shrink-0"
                      }),
                      _vm._v(" "),
                      _c("BlInputDate", {
                        attrs: {
                          input: _vm.endDateInput,
                          dense: "",
                          disabledManualInput: ""
                        },
                        on: { changed: _vm.onChangeDate }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.useDateInputs
                ? _c("div", {
                    staticClass: "h-7.5 w-0.5 bg-slate-300 flex-shrink-0"
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: {
                  type: "outlined-error",
                  dense: "",
                  label: "Delete graph",
                  loading: _vm.removeLoading
                },
                on: { clicked: _vm.onRemoveSection }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c24d9d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c24d9d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/editor/ReportGraph.vue
// module id = null
// module chunks = 